import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../StyleSheet";
const { Text } = Typography;

interface InfoCardProps {
    title?: string;
    description?: string;
    color?: string;
    colorText?: string;
}

const InfoCardComponent = (props: InfoCardProps) => {
    const { title, description, colorText, color } = props;
    return (
        <Card style={{...styles.rowRoot, backgroundColor: color ? color : "#c5d5e4"}} styles={{ body: { padding: 15 } }}>
            <Row>
                <Col span={6} style={styles.firstColumn}>
                    <InfoCircleOutlined style={{...styles.icon, color: colorText ? colorText : "#0e5ea5"}} />
                </Col>
                <Col span={18} style={styles.secondColumn}>
                    <>
                        {
                            title ?
                            <div style={{...styles.textTitle, color: colorText ? colorText : "#0e5ea5"}}>
                                    {title}
                                </div>
                                : null
                        }
                        {
                            description ?
                            <Text style={{...styles.textDescription, color: colorText ? colorText : "#0e5ea5"}}>
                                    {description}
                                </Text>
                                :
                                null
                        }
                    </>
                </Col>
            </Row>
        </Card>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        borderRadius: 15,
        border: "none",
        width: "100%",
    },
    icon: {
        fontSize: 40,
    },
    textTitle: {
        fontSize: 15,
        fontWeight: 'bold',
        width: "95%"
    },
    textDescription: {
        fontSize: 13,
        width: "95%"
    },
    firstColumn: {
        justifyContent: 'center',
        display: 'flex'
    },
    secondColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
});

export default InfoCardComponent;
